import { render } from "./OptimizedImg.vue?vue&type=template&id=3231ec05&scoped=true"
import script from "./OptimizedImg.vue?vue&type=script&lang=js"
export * from "./OptimizedImg.vue?vue&type=script&lang=js"

import "./OptimizedImg.vue?vue&type=style&index=0&id=3231ec05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3231ec05"]])

export default __exports__